import {useCallback, useEffect, useState} from "react";
import {getPromptHistory} from "../api/promptHistoryApi.js";

export default function usePromptHistory(entityType, entityId)
{
	const [history, setHistory] = useState([]);
	const [total, setTotal] = useState(0);
	const [loading, setLoading] = useState(false);

	const loadHistory = useCallback(async (limit = 20, offset = 0) =>
	{
		if (!entityType || !entityId)
			return;

		setLoading(true);
		try
		{
			const result = await getPromptHistory({entityType, entityId, limit, offset});
			if (result.ok !== false)
			{
				setHistory(result.items || []);
				setTotal(result.total || 0);
			}
		}
		catch (e)
		{
			// silenzioso
		}
		finally
		{
			setLoading(false);
		}
	}, [entityType, entityId]);

	useEffect(() =>
	{
		loadHistory();
	}, [loadHistory]);

	return {history, total, loading, loadHistory};
}
